import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbf528b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  width: "30.000000pt",
  height: "30.000000pt",
  viewBox: "0 0 30.000000 30.000000",
  preserveAspectRatio: "xMidYMid meet",
  class: "icon-lightning"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    transform: "translate(0.000000,30.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M117 211 c-20 -37 -37 -71 -37 -75 0 -3 11 -6 25 -6 24 0 25 -3 25\n                -55 0 -30 4 -55 8 -55 7 0 82 131 82 144 0 3 -11 6 -25 6 -24 0 -25 3 -25 55\n                0 30 -4 55 -8 55 -4 0 -24 -31 -45 -69z",
      fill: "none"
    })
  ])
], -1))
const _hoisted_2 = [
  _hoisted_1
]

import { computed } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'

export default /*#__PURE__*/_defineComponent({
  props: {
  cno: {
    type: Number,
  },
  state: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { t } = useI18nTl('Evses')

const name = 'IconLightning'

const color = computed(() => {
  switch (props.state) {
    case 1: // 空闲
      return '#00be73'
    case 2: // 已连接，未开启充电会话
      return '#8fff9b'
    case 3: // 充电中
      return '#ff9300'
    case 4: // 充电已开启，但充电桩还未输出
      return '#FFD700'
    case 5: // 充电已开启，电动汽车还未充电
      return '#FFA500'
    case 6: // 充电完成，还处于占用状态
      return '#00ffa2'
    case 7: // 预约
      return '#B10DC9'
    case 8: // 故障
      return '#FF0000'
    case 9: // 定时充电等待、轮充等待等
      return '#808080'
    case 10: // 设备占用中
      return '#555555'
  }
  return '#808080'
})
const tips = computed(() => {
  let connectDesc = t('Evses.connectorStateUnavailable')
  switch (props.state) {
    case 1:
      connectDesc = t('Evses.connectorStateAvailable')
      break
    case 2:
      connectDesc = t('Evses.connectorStatePreparing')
      break
    case 3:
      connectDesc = t('Evses.connectorStateCharging')
      break
    case 4:
      connectDesc = t('Evses.connectorStateSuspendedEVSE')
      break
    case 5:
      connectDesc = t('Evses.connectorStateSuspendedEV')
      break
    case 6:
      connectDesc = t('Evses.connectorStateFinishing')
      break
    case 7:
      connectDesc = t('Evses.connectorStateReserved')
      break
    case 8:
      connectDesc = t('Evses.connectorStateFaulted')
      break
    case 9:
      connectDesc = t('Evses.connectorWaiting')
      break
    case 10:
      connectDesc = t('Evses.connectorOccupied')
      break
  }
  return t('Evses.cno') + ' ' + props.cno + ' ' + t('Evses.state') + ': ' + connectDesc
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    class: "item",
    effect: "dark",
    content: _unref(tips),
    placement: "top"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "icon-wrapper",
        style: _normalizeStyle({ color: _unref(color) })
      }, _hoisted_2, 4)
    ]),
    _: 1
  }, 8, ["content"]))
}
}

})